// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"26e850ee","553":"0b38eed3","977":"84758877"}[chunkId] + ".chunk.js";
};